import React from 'react';
import { DashboardModal } from 'containers/Dashboard/components/DashboardModal';
import { Alert } from 'reactstrap';
import __ from 'utils/i18n';

export const CancelPlanModal = ({ 
  showModal = false, 
  hideModal, 
  plan, 
  submitAction, 
  submitDisabled = false 
}) => {
  if (!plan) return null;

  return (
    <DashboardModal
      name="cancelPlanModal"
      headerText={__('dashboard.sections.recurringPayments.plans.cancelModal.title', { planName: plan.name })}
      showModal={showModal}
      hideModal={hideModal}
      submitAction={submitAction}
      submitColor="danger"
      submitDisabled={submitDisabled}
      hideSeparator={true}
      cancelText={__('dashboard.sections.recurringPayments.plans.cancelModal.cancelButton')}
      submitText={submitDisabled 
        ? __('dashboard.sections.recurringPayments.plans.cancelModal.canceling')
        : __('dashboard.sections.recurringPayments.plans.cancelModal.confirmButton')
      }
    >
      <div>
        <p className="mb-3">
          {__('dashboard.sections.recurringPayments.plans.cancelModal.description')}
        </p>
        
        <Alert color="warning" className="d-flex align-items-start mb-0">
          <i className="mdi mdi-alert mr-2 mt-1" style={{ fontSize: '20px' }}></i>
          <span>
            {__('dashboard.sections.recurringPayments.plans.cancelModal.warning')}
          </span>
        </Alert>
      </div>
    </DashboardModal>
  );
};

